import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React, { Component } from 'react';

import { DeleteMachineTicketTask } from '../../../../../../actions/index';
import Task from '../../../../../../models/Task';
import Button from '../../../../../common/Button';

interface IProps {
  task: Task;
  deleteMachineTicketTask: (properties: DeleteMachineTicketTask) => void;
  handleClose: () => void;
  loading: boolean;
}

class TaskModal extends Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  public handleDelete() {
    const { deleteMachineTicketTask, task } = this.props;

    deleteMachineTicketTask({
      ticketid: task.ticketid,
      id: task.id,
    });
  }

  public render() {
    const {
      handleClose,
      loading,
      task,
    } = this.props;

    return (
      <Dialog maxWidth="md" fullWidth open>
        <DialogTitle>
          <span>Apagar tarefa - {task.title}</span>
          <IconButton edge="end" size="small" className="dialog-close-button" onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">Tem a certeza que pretende apagar esta tarefa?</Typography>
        </DialogContent>
        <DialogActions>
          <Box mt={2}>
            <Grid container spacing={1}>
              <Grid item>
                <Button color="default" variant="contained" onClick={() => handleClose()}>
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  startIcon={
                    <FontAwesomeIcon icon={faTrash} />
                  }
                  variant="contained"
                  onClick={this.handleDelete}
                >{loading ? <CircularProgress size={24} /> : 'Apagar'}</Button>
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Dialog>
    );
  }
}

export default TaskModal;
